import { useState, useEffect } from "react";

interface CountdownProps {
  targetDate: string; // Format: "YYYY-MM-DDTHH:mm:ss"
}

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export function Countdown({ targetDate }: CountdownProps) {
  const calculateTimeLeft = (): TimeLeft => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft: TimeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  function pad(num: number) {
    return num.toString().padStart(2, "0");
  }

  const timeUnits = [
    { label: "DIAS", value: pad(timeLeft.days) },
    { label: "HORAS", value: pad(timeLeft.hours) },
    { label: "MIN", value: pad(timeLeft.minutes) },
    { label: "SEG", value: pad(timeLeft.seconds) },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mt-8 sm:mt-12">
      {timeUnits.map((item, index) => (
        <div
          key={index}
          className="flex flex-col items-center justify-center w-20 h-24 sm:w-24 sm:h-28 md:w-28 md:h-32 rounded-xl border border-[#EA9D00] bg-black/40 backdrop-blur-sm shadow-lg overflow-hidden"
        >
          <span className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#EA9D00] leading-none mb-1">
            {item.value}
          </span>
          <span className="text-[10px] sm:text-xs md:text-sm font-bold text-white tracking-wider uppercase">
            {item.label}
          </span>
        </div>
      ))}
    </div>
  );
}
